import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo.svg'


const _hoisted_1 = { class: "t-login flex flex-col w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "t-login__header flex justify-center mb-6" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "t-login__header-logo w-60",
    src: _imports_0,
    alt: "logo"
  })
], -1)
const _hoisted_3 = { class: "t-login__content" }
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", {
  id: "login-heading",
  class: "text-primary-gc text-2.5xl mb-6"
}, " Selamat Datang! ", -1)
const _hoisted_6 = { class: "t-login__content-form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormLogin = _resolveComponent("FormLogin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_FormLogin, {
            "initial-error": _ctx.error,
            "is-loading": _ctx.isLoading,
            "form-data": _ctx.formData,
            onSubmit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('submit', $event)))
          }, null, 8, ["initial-error", "is-loading", "form-data"])
        ])
      ])
    ])
  ]))
}